import { Query } from '@tanstack/react-query'

import {
  GetFixedPromptTextGenerationOut,
  GetFixedPromptTextGenerationOutState,
} from 'lib/apiClient'

import { POLLING_DELAY } from './FixedPromptTextGeneration.constants'

export const getPromptRefetchInterval = (
  query: Query<
    GetFixedPromptTextGenerationOut,
    Error,
    GetFixedPromptTextGenerationOut,
    (string | undefined)[]
  >,
) => {
  const latestState = query.state.data?.state

  if (
    latestState === GetFixedPromptTextGenerationOutState.Pending ||
    latestState === GetFixedPromptTextGenerationOutState.InProgress
  ) {
    return POLLING_DELAY
  }

  return false
}
